export default {
  middleware_url: "https://demo.livraisons.pro",
  cake_url: "https://demo.cake.livraisons.pro",
  isWavesoftEnabled: false,
  billingConforamaEnabled: false,
  isUrbantzEnabled: false,
  showLockBillingButton: true,
};
